import { RpcService } from 'rpc';
const baseurl = window.hcstatic.portal_url;
const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${baseurl}/@@timesync.rpc`,
    services: {
        server_time: {
            parameters: [
                {
                    name: 'clienttime',
                    type: 'integer',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
